import { Selector, State, StateContext, Action, Store } from '@ngxs/store';
import { ClearQuestionsStore, GetQuestions, GetUnansweredQuestions, UpdateAnansweredQuestions } from './question.action';
import { mergeMap, tap } from 'rxjs/operators';
import { QuestionService } from 'app/services/question/question.service';
import { FilterQuestion } from 'app/models/dto/question.model';
import _ from 'lodash';
import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';

export class QuestionsStateModel {
  questionsByAlias: {
    [alias: string]: FilterQuestion;
  };
  allQuestions: BorrowerValue[] | null;
  remainingDocs: BorrowerValue[];
}

@State<QuestionsStateModel>({
  name: 'question',
  defaults: {
    questionsByAlias: {},
    allQuestions: null,
    remainingDocs: []

  }
})

@Injectable()

export class QuestionsState {

  @Selector()
  static questions(state: QuestionsStateModel) {
    return (alias: string) => state.questionsByAlias;
  }

  @Selector()
  static allQuestions(state: QuestionsStateModel) {
    return state.allQuestions;
  }

  constructor(
    private questionsService: QuestionService,
    private store: Store
  ) { }



  @Action(GetQuestions)
  getQuestions({ getState, patchState }: StateContext<QuestionsStateModel>, { }: GetQuestions) {
    const currentQuestions = getState().questionsByAlias;
    if (Object.keys(currentQuestions).length) {
      return;
    }
    return this.questionsService.getQuestions().pipe(tap(questions => {
      const questionsByAlias = _.keyBy(questions, 'alias');
      patchState({ questionsByAlias });
    }));
  }

  @Action(GetUnansweredQuestions)
  getUnansweredQuestions({ patchState }: StateContext<QuestionsStateModel>, { borrowerId }: GetUnansweredQuestions) {
    return forkJoin([
      this.questionsService.getQuestionsforBorrower(borrowerId),
      this.questionsService.getInformationalQuestionsforBorrower(borrowerId)
    ])
      .pipe(
        tap((result) => {
          const totalQuestions = result.flat();
          // remove duplicate data
          const allQuestions = _(totalQuestions)
            .uniqBy(question => question.alias)
            .value();
          patchState({ allQuestions });
        }),
        mergeMap(() => this.questionsService.getDocumentQuestions(borrowerId)
          .pipe(
            tap(questions => {
              const remainingDocs = _(questions)
                .reject(function (question) {
                  const documents = _.get(question, 'documents', []);
                  return documents.length > 0;
                })
                .value();
              patchState({ remainingDocs });
            })
          )
        ));
  }

  @Action(UpdateAnansweredQuestions)
  UpdateAnansweredQuestions({ patchState }: StateContext<QuestionsStateModel>, { borrowerId, modifiedValue }: UpdateAnansweredQuestions) {
    return this.questionsService.updateAnswers(borrowerId, modifiedValue)
      .pipe(
        tap((result) => {

          patchState({ allQuestions: result });
        })
      );
  }



  @Action(ClearQuestionsStore)
  clearBorrowerStore({ patchState }: StateContext<QuestionsStateModel>, { }: ClearQuestionsStore) {
    patchState({ questionsByAlias: {} });
  }
}
